import React from 'react';
import AuthLayout from '../components/vsCodeAuth/AuthLayout';
import ResetPassword from '../components/vsCodeAuth/ResetPassword';
import { Title } from '../styles/vsCodeAuthStyles/authLayoutStyles';

const VsCodeResetPassword = () => {
  return (
    <AuthLayout>
      <Title>Reset Password</Title>
      <ResetPassword />
    </AuthLayout>
  );
};

export default VsCodeResetPassword;
